import { Staff } from "modules/staff";

const StaffPage = () => {
  return <Staff />;
};

export default StaffPage;
